export const errors = {
    businessName: "Please fill in business name",
    emailAddress: "Please fill in email address",
    isEmailValid:"Please enter a valid email or clear your selection",
    phoneNumber: "Please fill in phone number",
    staffStrength: "Please fill in no of youths trained",
    location: "Please specify business location"
  };